import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { stat } from "fs"

export interface DashboardSliceState {
    userCount: number | null
    lastSync: string | null
    isLoadingData: boolean,
}

export const initialState: DashboardSliceState = {
    userCount: null,
    lastSync: null,
    isLoadingData: false
}


const dashboardSlice = createSlice({
    name: 'opportunities',
    initialState,
    reducers: {
        setDashbaordData(state, { payload }: PayloadAction<{
            userCount: number,
            lastSync: string
        }>) {
            state.userCount = payload.userCount
            state.lastSync = payload.lastSync
        },
        setIsLoadingData(state, { payload }: PayloadAction<boolean>) {
            state.isLoadingData = payload
        }
    }
})

export const {
    setDashbaordData, 
    setIsLoadingData
} = dashboardSlice.actions


export default dashboardSlice.reducer